import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from '@progress/kendo-react-buttons';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { StreetAddressViewModel } from '../StreetAddress';
import RegistrationChild, { ChildViewModel } from './Child';
import RegistrationGuardian, { GuardianViewModel } from './Guardian';
import RegistrationRelease, { ReleaseViewModel } from './Release';
import RegistrationAgreement, { AgreementViewModel } from './Agreements';
import RegistrationNavigation from './Navigation';
import { ApplicationState }  from '../../store';
import * as AuthenticationState from '../../store/authentication';
import { fetchPublicApi, JsonResponse } from '../../services/api';
const DocumentTitle = require('react-document-title');

type Props =
    AuthenticationState.AuthenticationState         // ... state we've requested from the Redux store
    & typeof AuthenticationState.actionCreators     // ... plus action creators we've requested
    & RouteComponentProps<{                         // ... plus incoming routing parameters
        accountId: string;
        token: string;
     }>;

type State = {
    TenantID: number;
    TenantName: string;
    FacilityID: number;
    Facilities: Array<{ FacilityId: number, Name: string }>;
    Children: ChildViewModel[];
    Guardians: GuardianViewModel[];
    Releases: ReleaseViewModel[];
    Agreements: AgreementViewModel[];
    IsLoading: boolean;
    Validation: boolean;
    sideNav: Navigation[];
    AcademicUser: boolean;
}

type Navigation = {
}

class Registration extends React.Component<Props, State> {

    constructor(props:Props){
        super(props);

        this.state = {
            TenantID: 0,
            TenantName: '',
            FacilityID: 0,
            Facilities: [],
            Children: [{
                FirstName: '',
                LastName: '',
                Gender: null,
                BirthDate: null,
                Phone: '',
                HomeAddress: {
                    Line1: '',
                    Line2: '',
                    City: '',
                    State: '',
                    Zip: ''
                } as StreetAddressViewModel,
                Breakfast: '',
                HasBreakfast: false,
                Lunch: '',
                HasLunch: false,
                Snack: '',
                HasSnack: false,
                NapOne1: null,
                NapOne2: null,
                NapTwo1: null,
                NapTwo2: null,
                NapThree1: null,
                NapThree2: null,
                BottleOne: null,
                BottleTwo: null,
                BottleThree: null,
                EmergencyFirstName: '',
                EmergencyLastName: '',
                EmergencyPhone: '',
                EmergencyRelation: '',
                EmergencyAddress: null,
                Healthcard: '',
                Height: 0,
                HeightUnitOfMeasure: 1,
                Weight: 0,
                WeightUnitOfMeasure: 1,
                Disability: '',
                Chronic: '',
                Disorder: '',
                Medication: '',
                Allergies: '',
                Dietary: '',
                Other: '',
                DoctorFirstName: '',
                DoctorLastName: '',
                DoctorPhone: '',
                DoctorAddress: null,
                HasDisability: false,
                HasChronic: false,
                HasDisorder: false,
                HasMedication: false,
                HasAllergies: false,
                HasDietary: false,
                HasMeasles: false,
                HasChickenPox: false,
                HasScarletFever: false,
                HasGermanMeasles: false,
                HasWhoopingCough: false,
                HasOther: false,
                Note: '',
            }],
            Guardians: [{
                GuardianID: 0,
                Relation: '',
                FirstName: '',
                LastName: '',
                MobilePhone: '',
                WorkName: '',
                WorkPhone: '',
                WorkPhoneExtension: '',
                WorkAddress: null,
            }],
            Releases: [],
            Agreements: [{
                Title: '',
                Body: '',
            }],
            IsLoading: false,
            Validation: false,
            sideNav: [],
            AcademicUser: false,
        }

        this.save = this.save.bind(this);
        this.addChild = this.addChild.bind(this);
        this.removeChild = this.removeChild.bind(this);
        this.addGuardian = this.addGuardian.bind(this);
        this.removeGuardian = this.removeGuardian.bind(this);
        this.addRelease = this.addRelease.bind(this);
        this.removeRelease = this.removeRelease.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        this.requestFacilities(this.getTenantName());
    }

    public render() {
        return <div className="container">
            <DocumentTitle title='Registration' />
            <br/>
            <h1 className="text-center">{this.state.TenantName} Child Registration</h1>
            <br/>
            <form className="k-form row">
                <div className="col-md-10">
                    <br/>
                    {this.state.Facilities.length > 0 &&
                        <DropDownList
                            defaultItem={{ Name: 'Select Location*', FacilityId: -1 }}
                            textField='Name'
                            className="child"
                            data={this.state.Facilities}
                            value={this.state.Facilities.find(x => x.FacilityId === this.state.FacilityID)}
                            onChange={(e) => {
                                this.setState({ FacilityID: e.target.value.FacilityId });
                            }}
                            style={{ width: '100%' }}
                        />
                    }
                    {(this.state.Validation && !this.state.FacilityID) ? <p className="error-msg">Location is Required</p> : <br/>}
                    {this.state.Children.map((child, index) => {
                        return <RegistrationChild child={child} index={index} Validation={this.state.Validation} key={index} onChange={(data)  => this.updateChild(data, index)} academicUser={this.state.AcademicUser} />
                    })}
                    <div className="d-flex justify-content-center float-left">
                        <Button className="btn-secondary" primary={true} onClick={this.addChild}>Add Another Child</Button>
                    </div>
                    {this.state.Children.length > 1 && <div>
                        <div className="d-flex justify-content-center float-right">
                            <Button className="btn btn-secondary" onClick={this.removeChild}>Remove Child</Button>
                        </div>
                    <br/>
                    <br/>
                    </div>}
                    <br/>
                    {!this.state.AcademicUser && <React.Fragment>
                        <br/>
                        <br/>
                        <div className="guardian">
                        {this.state.Guardians.map((guardian, index) => {
                            return <RegistrationGuardian guardian={guardian} index={index} Validation={this.state.Validation} key={index} onChange={(data) => this.updateGuardian(data, index)} />
                        })}
                        </div>
                        <div className="d-flex justify-content-center float-left">
                            <Button className="btn-secondary" primary={true} onClick={this.addGuardian}>Add Another Guardian</Button>
                        </div>
                        {this.state.Guardians.length > 1 && <div className="d-flex justify-content-center float-right">
                            <Button className="btn btn-secondary" onClick={this.removeGuardian}>Remove Guardian</Button>
                        </div>}
                        <br/>
                        <br/>
                        <br/>
                        <div className="release">
                            {this.state.Releases.map((release, index) => {
                                return <RegistrationRelease release={release} index={index} Validation={this.state.Validation} key={index} onChange={(data) => this.updateRelease(data, index)} />
                            })}
                        </div>
                        <div className="d-flex justify-content-center float-left">
                            <Button className="btn-secondary" primary={true} onClick={this.addRelease}>Add Release Authorization</Button>
                        </div>
                        {this.state.Releases.length > 0 && <div className="d-flex justify-content-center float-right">
                            <Button className="btn btn-secondary" onClick={this.removeRelease}>Remove Release Authorization</Button>
                        </div>}
                        <br/>
                        <br/>
                    </React.Fragment>}
                    <br/>
                    <div className="terms">
                        {this.state.Agreements.map((agreement, index) => {
                            return <RegistrationAgreement key={index} Agreement={agreement} index={index} Validation={this.state.Validation} />
                        })}
                    </div>
                    {!this.state.IsLoading && <Button primary onClick={this.save} style={{float:'right' }}>Submit Registration</Button>}
                    {this.state.IsLoading && <div className="k-loading-image" style={{position: 'relative'}} ></div>}
                    <br/>
                </div>
                <RegistrationNavigation Children={this.state.Children.length} academicUser={this.state.AcademicUser}> </RegistrationNavigation>
            </form>
            <p className="mt-5 mb-3 text-muted text-center">&copy; {(new Date()).getFullYear()} Daycarium</p>
        </div>
    }

    private save(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        this.setState({ Validation: true }, () => {
            const data = {
                ...this.state,
                AccountID: this.props.match.params.accountId,
                Token: this.props.match.params.token
            }
            if (document.getElementsByClassName("error-msg").length === 0) {
                this.setState({ IsLoading: true });
                fetchPublicApi(`/api/Registration/Index`, data, 'POST')
                    .then((response: JsonResponse) => {
                        this.setState({ IsLoading: false });
                        if (response.Success)
                        {
                            this.props.history.push("/registrationThankYou");
                        }
                        else
                        {
                            alert(`Error: ${response.ErrorMessage}`);
                        }
                    }).catch((error: Error) => {
                        this.setState({ IsLoading: false });
                        // TODO: Show error
                    })
            } else {
                document.getElementsByClassName("error-msg")[0].scrollIntoView({block: "center"})
            }
        });
    }

    private addChild(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        let children = this.state.Children;
        children.push({
            FirstName: '',
            LastName: '',
            Gender: null,
            BirthDate: null,
            Phone: '',
            HomeAddress: {
                Line1: '',
                Line2: '',
                City: '',
                State: '',
                Zip: ''
            } as StreetAddressViewModel,
            Breakfast: '',
            HasBreakfast: false,
            Lunch: '',
            HasLunch: false,
            Snack: '',
            HasSnack: false,
            NapOne1: null,
            NapOne2: null,
            NapTwo1: null,
            NapTwo2: null,
            NapThree1: null,
            NapThree2: null,
            BottleOne: null,
            BottleTwo: null,
            BottleThree: null,
            EmergencyFirstName: '',
            EmergencyLastName: '',
            EmergencyPhone: '',
            EmergencyRelation: '',
            EmergencyAddress: null,
            Healthcard: '',
            Height: 0,
            HeightUnitOfMeasure: 1,
            Weight: 0,
            WeightUnitOfMeasure: 1,
            Disability: '',
            Chronic: '',
            Disorder: '',
            Medication: '',
            Allergies: '',
            Dietary: '',
            Other: '',
            DoctorFirstName: '',
            DoctorLastName: '',
            DoctorPhone: '',
            DoctorAddress: null,
            HasDisability: false,
            HasChronic: false,
            HasDisorder: false,
            HasMedication: false,
            HasAllergies: false,
            HasDietary: false,
            HasMeasles: false,
            HasChickenPox: false,
            HasScarletFever: false,
            HasGermanMeasles: false,
            HasWhoopingCough: false,
            HasOther: false,
            Note: '',
        });
        this.setState({ Children: children });
    }

    private removeChild(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        let children = this.state.Children;
        children.pop()
        this.setState({ Children: children });
    }

    private updateChild(child: ChildViewModel, index: number) {
        const children = this.state.Children;
        children[index] = child;
        this.setState({Children: children});
    }

    private addGuardian(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        let guardians = this.state.Guardians;
        guardians.push({
            GuardianID: 0,
            Relation: '',
            FirstName: '',
            LastName: '',
            MobilePhone: '',
            WorkName: '',
            WorkPhone: '',
            WorkPhoneExtension: '',
            WorkAddress: null,
        });
        this.setState({ Guardians: guardians });
    }

    private removeGuardian(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        let guardians = this.state.Guardians;
        guardians.pop()
        this.setState({ Guardians: guardians });
    }

    private updateGuardian(guardian: GuardianViewModel, index: number) {
        const guardians = this.state.Guardians;
        guardians[index] = guardian;
        this.setState({ Guardians: guardians });
    }

    private addRelease(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        let releases = this.state.Releases;
        releases.push({
            ReleaseID: 0,
            Relation: '',
            FirstName: '',
            LastName: '',
            MobilePhone: '',
            Phone: '',
            Address: null,
        });
        this.setState({ Releases: releases });
    }

    private removeRelease(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        let releases = this.state.Releases;
        releases.pop()
        this.setState({ Releases: releases });
    }

    private updateRelease(release: ReleaseViewModel, index: number) {
        const releases = this.state.Releases;
        releases[index] = release;
        this.setState({ Releases: releases });
    }

    private getTenantName() {
        if (typeof window !== 'undefined') {
            if (window.location.hostname === 'localhost') {
                return 'ANC';
            }
            const hostname = window.location.hostname.split('.');
            return (hostname.length > 2) ? hostname[0].toUpperCase() : '';
        }
        if (this.props.subdomain) {
            return this.props.subdomain;
        }
        return '';
    }

    private requestFacilities(tenantName: string) {
        fetchPublicApi(`/api/Registration/GetRegistration`, { TenantName: tenantName }, 'POST')
            .then((response: { TenantID: number, TenantName: string, Facilities: Array<{ FacilityId: number, Name: string }>, Agreements: Array<{ Title: string, Body: string }>, AcademicUser: boolean}) => {
                // TODO: If empty array not accepting applicates currently
                var defaultFacilityID = (response.Facilities.length === 1) ? response.Facilities[0].FacilityId : this.state.FacilityID;
                this.setState({ 
                    TenantID: response.TenantID,
                    TenantName: response.TenantName,
                    Facilities: response.Facilities,
                    Agreements: response.Agreements,
                    AcademicUser: response.AcademicUser,
                    FacilityID: defaultFacilityID
                });
            }).catch((error: Error) => {
                window.location.href = 'https://daycarium.com/';
            })
    }
}

export default withRouter(connect(
    (state: ApplicationState) => state.authentication, // Selects which state properties are merged into the component's props
    AuthenticationState.actionCreators                 // Selects which action creators are merged into the component's props
)(Registration));

